<raf-text [gutterBottom]="gutterBottom" class="paper-horizontal-padding paper-header" [variant]="size === 'medium' ? 'h2' : 'h3'" color="primary-color"><ng-content></ng-content></raf-text>
